import { RSAA } from 'redux-api-middleware';
import { UpdateSocialButtonOrderRequest } from 'stageclip-common';

import { FormFieldsTypes } from 'components/portals/portalsForm/PortalForm.types';
import { toFormData } from 'helpers/requestHelper';
import { PortalsUploadListFormDataProps } from 'components/portals/portalsUploadListForm/PortalsUploadListForm.types';

const FETCH_PORTALS_LIST_REQUEST = 'FETCH_PORTALS_LIST_REQUEST';
const FETCH_PORTALS_LIST_SUCCESS = 'FETCH_PORTALS_LIST_SUCCESS';
const FETCH_PORTALS_LIST_FAILURE = 'FETCH_PORTALS_LIST_FAILURE';

export const fetchPortalList = () => ({
  [RSAA]: {
    types: [FETCH_PORTALS_LIST_REQUEST, FETCH_PORTALS_LIST_SUCCESS, FETCH_PORTALS_LIST_FAILURE],
    endpoint: '/portals',
    method: 'GET',
  },
});

const ADD_NEW_PORTAL_REQUEST = 'ADD_NEW_PORTAL_REQUEST';
const ADD_NEW_PORTAL_SUCCESS = 'ADD_NEW_PORTAL_SUCCESS';
const ADD_NEW_PORTAL_FAILURE = 'ADD_NEW_PORTAL_FAILURE';

export const addNewPortal = (body: FormFieldsTypes) => ({
  [RSAA]: {
    types: [ADD_NEW_PORTAL_REQUEST, ADD_NEW_PORTAL_SUCCESS, ADD_NEW_PORTAL_FAILURE],
    endpoint: '/portals',
    method: 'POST',
    body: toFormData(body),
  },
});

const EDIT_PORTAL_REQUEST = 'EDIT_PORTAL_REQUEST';
const EDIT_PORTAL_SUCCESS = 'EDIT_PORTAL_SUCCESS';
const EDIT_PORTAL_FAILURE = 'EDIT_PORTAL_FAILURE';

export const editPortal = (id: string, body: FormFieldsTypes) => ({
  [RSAA]: {
    types: [EDIT_PORTAL_REQUEST, EDIT_PORTAL_SUCCESS, EDIT_PORTAL_FAILURE],
    endpoint: `/portals/${id}`,
    method: 'PATCH',
    body: toFormData(body),
  },
});

const GET_SOCIAL_BUTTONS_REQUEST = 'GET_SOCIAL_BUTTONS_REQUEST';
const GET_SOCIAL_BUTTONS_SUCCESS = 'GET_SOCIAL_BUTTONS_SUCCESS';
const GET_SOCIAL_BUTTONS_FAILURE = 'GET_SOCIAL_BUTTONS_FAILURE';

export const getSocialButtons = () => ({
  [RSAA]: {
    types: [GET_SOCIAL_BUTTONS_REQUEST, GET_SOCIAL_BUTTONS_SUCCESS, GET_SOCIAL_BUTTONS_FAILURE],
    endpoint: '/add-to-any',
    method: 'GET',
  },
});

const EDIT_SOCIAL_BUTTONS_REQUEST = 'EDIT_SOCIAL_BUTTONS_REQUEST';
const EDIT_SOCIAL_BUTTONS_SUCCESS = 'EDIT_SOCIAL_BUTTONS_SUCCESS';
const EDIT_SOCIAL_BUTTONS_FAILURE = 'EDIT_SOCIAL_BUTTONS_FAILURE';

export const editSocialButtons = (body: UpdateSocialButtonOrderRequest[]) => ({
  [RSAA]: {
    types: [EDIT_SOCIAL_BUTTONS_REQUEST, EDIT_SOCIAL_BUTTONS_SUCCESS, EDIT_SOCIAL_BUTTONS_FAILURE],
    endpoint: '/add-to-any/order',
    method: 'PATCH',
    body,
  },
});

const UPLOAD_PORTALS_LIST_REQUEST = 'UPLOAD_PORTALS_LIST_REQUEST';
const UPLOAD_PORTALS_LIST_SUCCESS = 'UPLOAD_PORTALS_LIST_SUCCESS';
const UPLOAD_PORTALS_LIST_FAILURE = 'UPLOAD_PORTALS_LIST_FAILURE';

export const uploadPortalsList = (body: PortalsUploadListFormDataProps) => ({
  [RSAA]: {
    types: [UPLOAD_PORTALS_LIST_REQUEST, UPLOAD_PORTALS_LIST_SUCCESS, UPLOAD_PORTALS_LIST_FAILURE],
    endpoint: '/portals/import',
    method: 'POST',
    body: toFormData(body),
  },
});

const DELETE_PORTAL_REQUEST = 'DELETE_PORTAL_REQUEST';
const DELETE_PORTAL_SUCCESS = 'DELETE_PORTAL_SUCCESS';
const DELETE_PORTAL_FAILURE = 'DELETE_PORTAL_FAILURE';

export const deletePortal = (id: string) => ({
  [RSAA]: {
    types: [DELETE_PORTAL_REQUEST, DELETE_PORTAL_SUCCESS, DELETE_PORTAL_FAILURE],
    endpoint: `/portals/${id}`,
    method: 'DELETE',
  },
});

export const clearPortalCache = (portalDomain: string) =>
  fetch(
    `${process.env.REACT_APP_PORTALS_PROTOCOL}://${portalDomain}${
      process.env.REACT_APP_PORTALS_PORT ? `:${process.env.REACT_APP_PORTALS_PORT}` : ''
    }/api/flush`,
    {
      method: 'POST',
      headers: { 'x-api-access-token': `${process.env.REACT_APP_PORTALS_API_TOKEN}` },
    },
  ).then(res => (res.status >= 400 ? Promise.reject(res.json()) : res.json()));
